import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateOrderFulfillmentContainerStationManualAmountMutationVariables = Types.Exact<{
  order_fulfillment_id: Types.Scalars['ID'];
  manual_amount: Types.ContainerTypeAmountInput;
  container_station_id: Types.Scalars['ID'];
}>;


export type UpdateOrderFulfillmentContainerStationManualAmountMutation = { __typename?: 'Mutation', updateOrderFulfillmentContainerStationManualAmount: { __typename?: 'OrderFulfillment', id: string } };


export const UpdateOrderFulfillmentContainerStationManualAmountDocument = gql`
    mutation UpdateOrderFulfillmentContainerStationManualAmount($order_fulfillment_id: ID!, $manual_amount: ContainerTypeAmountInput!, $container_station_id: ID!) {
  updateOrderFulfillmentContainerStationManualAmount(
    order_fulfillment_id: $order_fulfillment_id
    manual_amount: $manual_amount
    container_station_id: $container_station_id
  ) {
    id
  }
}
    `;
export type UpdateOrderFulfillmentContainerStationManualAmountMutationFn = Apollo.MutationFunction<UpdateOrderFulfillmentContainerStationManualAmountMutation, UpdateOrderFulfillmentContainerStationManualAmountMutationVariables>;

/**
 * __useUpdateOrderFulfillmentContainerStationManualAmountMutation__
 *
 * To run a mutation, you first call `useUpdateOrderFulfillmentContainerStationManualAmountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderFulfillmentContainerStationManualAmountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderFulfillmentContainerStationManualAmountMutation, { data, loading, error }] = useUpdateOrderFulfillmentContainerStationManualAmountMutation({
 *   variables: {
 *      order_fulfillment_id: // value for 'order_fulfillment_id'
 *      manual_amount: // value for 'manual_amount'
 *      container_station_id: // value for 'container_station_id'
 *   },
 * });
 */
export function useUpdateOrderFulfillmentContainerStationManualAmountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderFulfillmentContainerStationManualAmountMutation, UpdateOrderFulfillmentContainerStationManualAmountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderFulfillmentContainerStationManualAmountMutation, UpdateOrderFulfillmentContainerStationManualAmountMutationVariables>(UpdateOrderFulfillmentContainerStationManualAmountDocument, options);
      }
export type UpdateOrderFulfillmentContainerStationManualAmountMutationHookResult = ReturnType<typeof useUpdateOrderFulfillmentContainerStationManualAmountMutation>;
export type UpdateOrderFulfillmentContainerStationManualAmountMutationResult = Apollo.MutationResult<UpdateOrderFulfillmentContainerStationManualAmountMutation>;
export type UpdateOrderFulfillmentContainerStationManualAmountMutationOptions = Apollo.BaseMutationOptions<UpdateOrderFulfillmentContainerStationManualAmountMutation, UpdateOrderFulfillmentContainerStationManualAmountMutationVariables>;